import { CollectionChainType } from '@app/client/common/structs/daas/v2/common/chains';
import config from '@app/config';

const { nftOpenseaLink, tokenContractAddress } = config;

interface NftDetailsUrlType {
    contractAddress: string;
    tokenId: string;
    chain?: string | CollectionChainType;
    goBackEnabled?: boolean;
}

export function getCollectionEthUrl(slug = '', chain?: CollectionChainType) {
    // TODO: This address needs to allow `eth` segment to be customized.
    return slug.length ? `/collection/${chain}/${slug}` : undefined;
}

export function getNftDetailsUrl({
    contractAddress,
    tokenId,
    chain = CollectionChainType.Ethereum,
    goBackEnabled = false,
}: NftDetailsUrlType) {
    let suffix = '';
    const search = {};

    if (goBackEnabled) {
        search['goBack'] = '1';
    }

    if (Object.keys(search).length) {
        suffix = `?${new URLSearchParams(search).toString()}`;
    }

    return `/collectible/${chain.toLowerCase()}/${contractAddress}/${tokenId}${suffix}`;
}

export function getOpenSeaMintedYatUrl(tokenId?: string | number | null) {
    const safeToken = tokenId ? `${tokenId}` : '';
    const chain = process.env.NODE_ENV === 'development' ? 'sepolia' : 'ethereum';
    // `ethereum` may not be required in the url.
    return safeToken
        ? `${nftOpenseaLink}/${chain}/${tokenContractAddress}/${safeToken}`
        : 'https://opensea.io/collection/yat';
}

export function getAppUrl(path: string) {
    const publicUrl = config.publicUrl;
    const linkPrefix = `${window.location.protocol}//`;
    const baseUrl = `${linkPrefix}${publicUrl}`;

    return path.substring(0, 1) !== '/' ? `${baseUrl}/${path}` : `${baseUrl}${path}`;
}
